import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import ProfileDesktop from '../components/faraaz/ProfileDesktop'
import ProfileMobile from '../components/faraaz/ProfileMobile'
import Riya from '../assets/images/Riya.jpg'

const MohammadSalmanBadusha = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <Helmet>
                <meta name="robots" content="noindex" />
                <meta charSet="utf-8" />
                <title>Mohammad Salman Badusha - 800 Homes</title>
            </Helmet>

            <section id="website-responsive" className="d-none d-md-block">
                <ProfileDesktop
                    Image={Riya}
                    Title="Mohammad Salman Badusha"
                    Designation="Senior Property Consultant"
                    PhoneNumberLink="+971501542729"
                    PhoneNumber="+971 50 154 2729"
                    WhatsappLink="971501542729"
                    Whatsapp="+971 50 154 2729"
                    Email="riya@800homes.ae"
                />
            </section>

            <section id="website-responsive" className="d-block d-md-none">
                <ProfileMobile
                    Image={Riya}
                    Title="Mohammad Salman Badusha"
                    Designation="Senior Property Consultant"
                    PhoneNumberLink="+971501542729"
                    PhoneNumber="+971 50 154 2729"
                    WhatsappLink="971501542729"
                    Whatsapp="+971 50 154 2729"
                    Email="riya@800homes.ae"
                />
            </section>
        </>
    )
}

export default MohammadSalmanBadusha
